import { EServices } from '../types/tableHelper'

/**
 * Определение «сервис лежит».
 *
 * У каждого парсера свой нормальный круг: Skinport и CS Float обновляются за минуты,
 * Mannco по Dota2 и AimMarket по CS2 штатно идут больше часа, Shadowpay по CS2 при
 * медленном API площадки — несколько часов. Поэтому один порог на всех даёт ложные
 * срабатывания: сервис работает, а мы рисуем техработы.
 *
 * Порог задаётся в часах на сервис, для остальных берётся DEFAULT_STALE_HOURS.
 */
const DEFAULT_STALE_HOURS = 3

const STALE_HOURS: Partial<Record<EServices, number>> = {
	[EServices.Shadowpay]: 8,
	[EServices.Mannco]: 5,
	[EServices.AimMarket]: 4,
	[EServices.Skinrave]: 6,
	[EServices.PirateSwap]: 6,
	[EServices.ManncoTrade]: 6,
	[EServices.SkinSwap]: 5,
	[EServices.ITrade]: 5,
	[EServices.SkinPlace]: 5,
	[EServices.Csgoroll]: 5,
}

export const getStaleHours = (service: EServices): number =>
	STALE_HOURS[service] ?? DEFAULT_STALE_HOURS

/** Возраст данных в часах. 0 (нет отметки времени) считаем свежим: время просто неизвестно. */
export const getDataAgeHours = (updatedAtUnix: number): number =>
	!updatedAtUnix ? 0 : (Date.now() / 1000 - updatedAtUnix) / 3600

export const isServiceStale = (service: EServices, updatedAtUnix: number): boolean =>
	!!updatedAtUnix && getDataAgeHours(updatedAtUnix) >= getStaleHours(service)

/** «7 часов», «2 дня» — для текста плашки. */
export const formatDataAge = (updatedAtUnix: number, lang: { Common_Hours: string; Common_Days: string }): string => {
	const hours = Math.floor(getDataAgeHours(updatedAtUnix))

	if (hours < 48) {
		return `${hours} ${plural(hours, lang.Common_Hours)}`
	}

	const days = Math.floor(hours / 24)
	return `${days} ${plural(days, lang.Common_Days)}`
}

/**
 * Русские окончания: 1 час, 2 часа, 5 часов. Формы приходят из языкового файла
 * строкой «час|часа|часов», чтобы английская версия просто отдала «hour|hours|hours».
 */
export const plural = (n: number, forms: string): string => {
	const [one, few, many] = forms.split('|')
	const mod100 = n % 100
	const mod10 = n % 10

	if (mod100 >= 11 && mod100 <= 14) return many
	if (mod10 === 1) return one
	if (mod10 >= 2 && mod10 <= 4) return few
	return many
}
